import { useState, useEffect } from 'react';
import { subscribeToTenantPermissions, hasPermission } from '../services/firestore/permissionService';

/**
 * Hook to manage and check user permissions within a tenant
 */
export const usePermissions = (userData) => {
    const [rolePermissions, setRolePermissions] = useState({});
    const [ownerRoles, setOwnerRoles] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!userData?.tenantId) {
            setLoading(false);
            return;
        }

        const unsubscribe = subscribeToTenantPermissions(userData.tenantId, (data) => {
            setRolePermissions(data.rolePermissions);
            setOwnerRoles(data.ownerRoles || []);
            setLoading(false);
        });

        return () => unsubscribe();
    }, [userData?.tenantId]);

    const isOwnerRole = userData?.role && ownerRoles.includes(userData.role);

    const can = (feature, action) => {
        if (!userData?.role) return false;

        // Super admin (Consultant) can do everything
        if (userData.role === 'consultant') return true;



        const userRolePermissions = rolePermissions[userData.role];
        return hasPermission(userRolePermissions, feature, action);
    };

    return { can, loading, rolePermissions, ownerRoles, isOwner: isOwnerRole, user: userData };
};
